import React, { forwardRef } from "react";
import img from "../../assets/images/slides/home-bg-34.jpg";
import imgWaves from "../../assets/images/slides/wave.svg";
import imgPeople from "../../assets/images/heroimage.jpeg";
import imgApp from "../../assets/images/appImagen.jpeg";

const ParallaxAppStyle = forwardRef((props, ref) => (
  <section className="pt-0 pb-0" id="home" ref={ref}>
    <div
      className="full-screen-bg"
      style={{
        backgroundImage: `url(${imgPeople})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
    >
      <div className="hero-text-wrap app-gradient-overlay">
        <div className="hero-text white-color hero-text-sm">
          <div className="container text-left">
            <div className="row">
              <div className="col-md-6 pt-120 pb-100 col-sm-6">
                <h2
                  className="white-color font-100"
                  data-aos-delay={100}
                  data-aos={"fade-up"}
                >
                  <span className="font-700">¡Jamás volverás</span> a perder el tiempo al recoger
                  <span className="font-700">a tus hijos en la escuela!</span>
                </h2>
                <p
                  className="white-color mt-30 lead"
                  data-aos-delay={300}
                  data-aos={"fade-up"}
                >
                  Ya intentaron de todo en tu escuela y se sigue perdiendo el tiempo a la hora de recoger a
                  tus hijos?
                  Las filas son eternas, avanzan muy lento y solo reyna el caos en la vialidad escolar? Si tu
                  respuesta es <b>SI</b> por lo menos a una pregunta, esto es para ti.
                </p>
                
              </div>
              <div className="col-md-4 offset-md-2 col-sm-4 offset-sm-2 mt-80">
                <div className="i-phones">
                  <img
                    className="img-fluid"
                    src={imgApp}
                    alt=""
                    data-aos-delay={100}
                    data-aos={"fade-left"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-shape-img">
        <img className="img-fluid" alt="wave-shape" src={imgWaves} />
      </div>
    </div>
  </section>
));

export default ParallaxAppStyle;
